"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParcelCheckPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var routes_1 = require("../../../../constants/routes");
var lmf_logo_png_1 = __importDefault(require("../../../../assets/logos/lmf_logo.png"));
var delivery_bike_png_1 = __importDefault(require("../../../../assets/backgrounds/delivery_bike.png"));
var lmf_order_tracking_background_png_1 = __importDefault(require("../../../../assets/backgrounds/lmf_order_tracking_background.png"));
var get_parcel_thunk_1 = require("../../../../reducers/slices/parcels/thunks/get_parcel_thunk");
var ParcelCheckPage = function () {
    var code = (0, react_router_dom_1.useParams)().code;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _a = (0, react_redux_1.useSelector)(function (state) { return state.parcelState; }), isLoadingParcels = _a.isLoadingParcels, parcel = _a.parcel;
    var _b = (0, react_1.useState)(""), trackingCode = _b[0], setTrackingCode = _b[1];
    var _c = (0, react_1.useState)(true), init = _c[0], setInit = _c[1];
    (0, react_1.useEffect)(function () {
        console.log("code ===>", code);
        if (code) {
            setTrackingCode(code);
        }
    }, []);
    (0, react_1.useEffect)(function () {
        if (!init && parcel._id) {
            navigate("".concat(routes_1.TRACK_PARCEL_ROUTE, "/").concat(parcel._id));
        }
    }, [parcel]);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "p-4" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-4 lg:grid lg:grid-cols-2" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-8" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "" }, { children: (0, jsx_runtime_1.jsx)("img", { src: lmf_logo_png_1.default, className: "w-1/3" }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-5xl" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "Order Tracking", bold: true, textColor: "text-black" }) })), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim." }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex gap-4" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.TextInputControl, { label: "Enter tracking code", size: "small", value: trackingCode, onChange: function (v) {
                                        setTrackingCode(v);
                                    } }), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.ButtonControl, { loading: isLoadingParcels, label: "Check", size: "small", backgroundColor: "bg-black", iconColor: "text-white", onClick: function () {
                                        setInit(false);
                                        dispatch((0, get_parcel_thunk_1.get_parcel_thunk)({
                                            code: trackingCode,
                                        }));
                                    } })] }))] })), (0, jsx_runtime_1.jsx)("div", __assign({ style: { backgroundImage: "url(".concat(lmf_order_tracking_background_png_1.default, ")") } }, { children: (0, jsx_runtime_1.jsx)("img", { src: delivery_bike_png_1.default, className: "mt-40" }) }))] })) })));
};
exports.ParcelCheckPage = ParcelCheckPage;
